import { RouteType } from "types/RouteType";

const DrawingDimensionRoute: RouteType = {
  name: "Drawing Dimension Extractor",
  path: "/drawing-dimension-extractor",
  layout: "/app",
  viewportCard: {
    header: {
      component: () => import("./DrawingDimensionHeader"),
      title: "Drawing Dimension Extractor",
      enableRefreshButton: false,
    },
    body: {
      component: () => import("./DrawingDimensionBody"),
      grayBackground: true,
    },
  },
  requiresAuth: true,
  requiresPermission: false,
  dialogs: [
    {
      name: "DrawingDimensionUpload",
      component: () => import("./dialogs/DrawingDimensionUploadDialog"),
      title: "Upload Drawing for Dimension Extraction",
      cancelButton: true,
      height: 600,
      onSubmit: async (rootStore: any) => {
        const viewStore = rootStore.drawingDimensionViewStore;
        if (
          !viewStore ||
          !viewStore.uploadingFiles ||
          viewStore.uploadingFiles.length === 0
        ) {
          return false;
        }

        try {
          await viewStore.uploadAndExtract();
          rootStore.routerStore.closeDialog();
          return true;
        } catch (error) {
          console.error("Upload failed:", error);
          return false;
        }
      },
    },
    {
      name: "DrawingDimensionViewer",
      component: () => import("./dialogs/DrawingDimensionViewer"),
      title: "Drawing Dimension Viewer",
      cancelButton: false,
      height: 660,
      fullWidth: true,
    },
    {
      name: "DrawingExportDialog",
      component: () => import("./dialogs/DrawingExportDialog"),
      title: "Export Dimension Data",
      cancelButton: true,
      height: 450,
      onSubmit: async (rootStore: any) => {
        const viewStore = rootStore.drawingDimensionViewStore;
        await viewStore.exportDimensions();
        return true;
      },
    },
  ],
  beforeEnter: async ({ rootStore }: any) => {
    // Dynamically import and initialize the ViewStore
    const { default: DrawingDimensionViewStore } = await import(
      "./DrawingDimensionViewStore"
    );

    // Initialize the ViewStore if not already done
    if (!rootStore.drawingDimensionViewStore) {
      rootStore.drawingDimensionViewStore = new DrawingDimensionViewStore(
        rootStore
      );
    }

    const viewStore = rootStore.drawingDimensionViewStore;

    // Check service availability and load extractions
    await viewStore.checkServiceAvailability();
    await viewStore.loadExtractions();

    return true;
  },
};

export default DrawingDimensionRoute;
